module.exports = __webpack_public_path__ + "img/pay2.4429a8e4.png";